<template>
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" :width="svgWidth" :height="svgHeight" viewBox="0 0 18.841 21.947" :class="iconCssClass">
    <title>{{$t('sammio.bookmarks.add_to_bookmarks')}}</title>
    <g data-id="sammio-favourite-single" transform="translate(1 1)">
      <path data-id="Path_4" data-name="Path 4" d="M1174.96,479.579V459.633H1191.8v19.947l-8.361-6.185Z" transform="translate(-1174.96 -459.633)" :fill="svgFill" :stroke="svgStroke" stroke-linejoin="round" :stroke-width="svgStrokeWidth"/>
    </g>
  </svg>

</template>
<script>
export default {
  name: 'FavouriteSingle',
  props: ['iconSize', 'iconFill', 'iconStroke', 'iconCssClass'],
  data() {
    return {
      svgWidth: "18.841",
      svgHeight: "21.947",
      svgFill: "none",
      svgStroke: "#236c6c",
      svgStrokeWidth: "2"
    }
  },
  computed: {
    getSize() {
      if (this.iconSize != undefined && this.iconSize !== "") {
        const multiplier = this.iconSize * 1
        this.svgWidth = this.svgWidth * multiplier
        this.svgHeight = this.svgHeight * multiplier
      }
    },
    getFill() {
      if (this.iconFill !== undefined && this.iconFill !== "") {
        return this.svgFill = this.iconFill
      }
      return this.svgFill
    },
    getStroke() {
      if (this.iconStroke !== undefined && this.iconStroke !== "") {
        this.svgStroke = this.iconStroke
      }
      return this.svgStroke
    }
  },
  mounted() {
    this.getSize
  }
}
</script>
